import Logo from "../../assets/logo-grupo-guerra-azul.png";

function LogoPage() {
  return (
    <img
      src={Logo}
      alt="logo-grupo-guerra"
      style={{
        width: 1350,
        height: 290,
      }}
    />
  );
}

export default LogoPage;
